import { formatDateString } from '@/utils/util';
import { Product, Seller, Warehouse } from '../api/product';
import { Product as ProductModel, Seller as SellerModel } from '../models/product';

export const mapProductsApiToModel = (data: Product[]): ProductModel[] =>
  data.map((product, index) => {
    return mapProductApiToModel(product, index);
  });

export const mapProductApiToModel = (
  product: Product,
  index: number,
): ProductModel => {
  return {
    id: product.id || index,
    is_in_cart: product.is_in_cart || false,
    meatType: product.meat_type ? product.meat_type : '-',
    meatLoin: product.meat_loin ? product.meat_loin : '-',
    cut: product.meat_loin ? product.meat_loin : '-',
    origin: product.origin ? product.origin : '-',
    warehouse: getWarehouseName(product.warehouse),
    brand: product.brand ? product.brand : '-',
    grade: product.grade ? product.grade : '-',
    storageType: product.storage_type ? product.storage_type : '-',
    est: product.EST ? product.EST === '0' ? '-' : product.EST : '-',
    averageWeight: product.average_weight
      ? {
        weight: product.average_weight,
        formatted: `${product.average_weight.toLocaleString()}`,
      }
      : {
        weight: 0,
        formatted: '0',
      },
    price: product.unit_price
      ? {
        amount: product.unit_price,
        formatted: `${product.unit_price.toLocaleString()}`,
      }
      : {
        amount: 0,
        formatted: '0',
      },
    stock: product.quantity
      ? {
        quantity: product.quantity,
        formatted: `${product.quantity.toLocaleString()}`,
      }
      : {
        quantity: 0,
        formatted: '0',
      },
    seller: product?.sellers?.[0]?.company
      ? product?.sellers?.[0]?.company
      : '-',
    sellers: product.sellers
      ? product.sellers.map((seller: Seller): SellerModel => ({
        company: seller.company || '-',
        name: seller.name || '-',
        phone_number: seller.phone_number || '-',
        email: seller.email || '',
      }))
      : [],
    expiryDate: product.expiration_date
      ? formatDateString(product.expiration_date)
      : '-',
    modifiedDays: product.days_since_update
      ? {
        days: product.days_since_update,
        formatted: `+${product.days_since_update}`,
      }
      : {
        days: 0,
        formatted: '0',
      },
    description: product.description ? product.description : '-',
  };
};

/**
 * warehouse 필드의 타입을 체크하고 적절한 값을 반환하는 함수
 * @param warehouse string | Warehouse | undefined 타입의 창고 값
 * @returns 문자열로 변환된 창고 이름 또는 '-'
 */
export function getWarehouseName(
  warehouse: string | Warehouse | undefined,
): string {
  if (!warehouse) {
    return '-';
  }

  if (typeof warehouse === 'string') {
    return warehouse;
  }

  // warehouse가 Warehouse 객체인 경우
  if (warehouse && typeof warehouse === 'object' && 'name' in warehouse) {
    return warehouse.name;
  }

  return '-';
}
